import React from 'react';
import {InertiaLink} from "@inertiajs/inertia-react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Inertia} from "@inertiajs/inertia";

const CategoryActionBtns = ({id, isShow}) => {

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this category?')) {
      Inertia.delete(route('categories.destroy', id));
    }
  }

  return (
    <div className='flex'>
        <button className='mr-3' onClick={handleDelete} data-tip="Remove category">
          <FontAwesomeIcon
            color={'red'}
            size={'lg'}
            icon={solid('xmark')}/>
        </button>

      <InertiaLink className='mr-3' href={route('categories.coupon', id)} data-tip="Featured coupons" >
        <FontAwesomeIcon
          color={'gold'}
          size={'lg'}
          icon={solid('arrow-up-right-dots')}/>
      </InertiaLink>
      {
        isShow === 1 ? (
          <InertiaLink data-tip="Hide coupon" href={route('categories.hide', id)}>
            <FontAwesomeIcon
              rotation={180}
              color={'gray'}
              size={'lg'}
              icon={solid('eye-slash')}/>
          </InertiaLink>
        ) : (
          <InertiaLink data-tip="Show coupon" href={route('categories.show', id)}>
            <FontAwesomeIcon
              rotation={180}
              color={'blue'}
              size={'lg'}
              icon={solid('eye')}/>
          </InertiaLink>
        )
      }
    </div>
  );
};

export default CategoryActionBtns;
